require("../../bootstrap");
require("../../plugins/modernizr-custom");
require("slick-carousel");
require("bootstrap");
require("@fancyapps/fancybox");
require("@fancyapps/fancybox/dist/jquery.fancybox.css");
require("../../plugins/mapify/jquery.mapify");
require("../../modal_promocion");

$(document).ready(function () {
    $(".up").on("click", function (e) {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: 0,
            },
            1000
        );
    });

    $(".scroll-to").click(function (e) {
        e.preventDefault();
        let target_id = "";
        if ($(this).data("scroll_to")) {
            target_id = $(this).data("scroll_to");
        } else {
            target_id = $(this).attr("href");
        }
        const $toElement = $(target_id);

        let alto_cabecera = 80;

        if ($toElement.length) {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $toElement.offset().top - alto_cabecera,
                },
                1000
            );
        }

        return false;
    });

    $(window).scroll(function () {
        let scrollTop = $(this).scrollTop();

        if (scrollTop > 5) {
            $("header").addClass("scroll");
            $("body").addClass("scroll");
        } else {
            $("header").removeClass("scroll");
            $("body").removeClass("scroll");
        }
    });
});

var mymap = L.map("mapid", {
    scrollWheelZoom: false,
}).setView([-39.2764751, -71.9809511], 14);

var icon = L.icon({
    iconUrl: "./../images/notros-de-alicura/marker-icon-2x.png",
    shadowUrl: "",

    iconSize: [25, 41], // size of the icon
    shadowSize: [0, 0], // size of the shadow
    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
    shadowAnchor: [4, 62], // the same for the shadow
    popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
});

var marker = L.marker([-39.2864751, -71.9909511], { icon: icon })
    .addTo(mymap)
    .bindPopup("Condominio Los Notros de Alicura")
    .openPopup();

L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    attribution: '&copy; <a href="https://openstreetmap.org/copyright">baluart.cl</a>'
}).addTo(mymap);



$("#bienvenida").find(".slide").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
});

$("#areas-comunes").find(".slide").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
});

$("#ubicacion-promos").find(".tarjetas").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
});

$(".btn-modelos").find(".btn").on("click", function () {
    var modeloId = $(this).data("id");

    $(".btn-modelos").find(".btn").removeClass("activo");
    $(this).addClass("activo");

    $(".modelo").removeClass("activo");
    $(modeloId).addClass("activo");

});

$(".tab-content").find(".lupa-nahuen").on("click", function () {
    $("[data-fancybox='planta-nahuen']").first().trigger("click");
});
$(".tab-content").find(".lupa-ollagua").on("click", function () {
    $("[data-fancybox='planta-nahuen']").first().trigger("click");
});

$("#terminaciones").find(".botones .btn").on("click", function () {
    var id = $(this).data("id");

    $("#terminaciones").find(".botones .btn").removeClass("activo");
    $(this).addClass("activo");

    $(".terminaciones").removeClass("activo");
    $(id).addClass("activo");

});


$("#terminaciones .img-cocina").mapify({
    popOver: {
        content: function (zone) {
            var top = $(".mapify-svg .mapify-hover").offset().top;
            var html_popup =
                "<strong>" + zone.attr("data-title") + "</strong>";
            return html_popup;
        },
        delay: 0.7,
        margin: "auto",
        height: "80px",
        width: "240px",
    },
});

$("#terminaciones .img-banio").mapify({
    popOver: {
        content: function (zone) {
            var top = $(".mapify-svg .mapify-hover").offset().top;
            var html_popup =
                "<strong>" + zone.attr("data-title") + "</strong>";
            return html_popup;
        },
        delay: 0.7,
        margin: "auto",
        height: "auto",
        width: "240px",
    },
});

$(".area").on("click", function () {
    var item = $(this).data("item");
    $(".item-ter").removeClass("activo");
    $(item).addClass("activo")
    console.log(item);
});

$(".btn-galeria").on("click", function () {
    var galeria = $(this).data("galeria");
    console.log(galeria)
    $("[data-fancybox='" + galeria + "']").first().trigger("click");
});

function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $("#navbarCollapse .nav-item a").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
            refElement.position().top - 100 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            $("#navbarCollapse .nav-item a").removeClass("active");
            currLink.addClass("active");
        } else {
            // currLink.removeClass("active");
        }
    });
}
$(document).on("scroll", onScroll);

$("#menu").on("click", function () {
    $(this).toggleClass("activo");
    $(".contenido-menu").toggleClass("activo");
})

$(".cerrar-promo").on('click', function (e) {
    e.preventDefault();
    $(".en-promocion").css("display", "none");
});

$("#loading").fadeOut();
// import("../../modal_promocion");
